import React from "react";
import img from "../assets/image 154.svg";
import img2 from "../assets/image 125.svg";
import StarRating from "../components/StarRating2";



const CreditCardHeading = ({ title, image, logo, rating, bankName }) => {
  return (
    <div className="">
      <div className=" flex items-center gap-3 mt-5 ml-4">
        <div className="w-[49px] h-[45px] rounded-[10px] border flex justify-center items-center">
          <img className=" w-[41px] h-[39px] bg-cover bg-center" src={logo} alt="Bank Logo" />
        </div>

        <p className="font-montserrat font-semibold text-[#5C5A5A] text-[14px]">
          {bankName?bankName:''}
        </p>
      </div>

      <div className=" py-3 flex flex-col items-center ">
        <div className="w-[156px] rounded-[5px] md:w-[20vw]">
          <img className="w-full bg-cover" src={image} alt="" />
        </div>
        <h1 className="font-montserrat font-semibold text-[#5C5A5A] text-[14px] mt-3">{title}</h1>
        <div className="h-[18.38px] w-[100px]">
          <StarRating activeStars={rating} />
        </div>
      </div>
    </div>
  );
};

export default CreditCardHeading;
